import axios from "axios";
import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { ModalLoader } from "../Components/ModalLoader";

import api from "../Services/api";
import { base_url_unico_api } from "../Utils/baseUrl";
import { usePrefeitura } from "./usePrefeitura";

export interface IGuia {
  ID: number;
  PERIODO: string;
  BASE: number;
  ISSQN: number;
  CPFINFORMANTE: string;
  DATA_INFORMACAO: string;
  CHAVE: string;
  FORNECEDOR: string;
  COMPUTADA: string;
  CANCELADA: string;
  VENCIMENTO: string;
  CODBARRA: string;
  PROCESSO: number;
  REGISTRO: number;
  databaixa: string | null;
}

export interface Order {
  PARAMETRO:
  | "PERIODO"
  | "STATUS"
  | "BASE"
  | "ISSQN"
  | "INFORMANTE"
  | "ISSQN"
  | "PROCESSO";

  ORDER: 1 | -1;
}

interface IGuiaContextData {
  chave: number;
  setChave: React.Dispatch<React.SetStateAction<number>>;
  numero: number;
  setNumero: React.Dispatch<React.SetStateAction<number>>;
  guia: IGuia;
  guias: IGuia[];
  setPeriodoInicial: React.Dispatch<React.SetStateAction<string>>;
  setPeriodoFinal: React.Dispatch<React.SetStateAction<string>>;
  loading: boolean;

  ordenacao: Order;
  setOrdenacao: React.Dispatch<React.SetStateAction<Order>>;
  handleOrdenacao(
    tipo:
      | "PERIODO"
      | "STATUS"
      | "BASE"
      | "ISSQN"
      | "INFORMANTE"
      | "ISSQN"
      | "PROCESSO"
  ): void;
  periodoInicial: string;
  periodoFinal: string;
  baseTotal: number;
  itbiTotal: number;
  somenteResumo: boolean;
  setSomenteResumo: React.Dispatch<React.SetStateAction<boolean>>;

  id_adquirinte: number;
  set_id_adquirinte: React.Dispatch<React.SetStateAction<number>>;

  tipo: "urbano" | "rural" | "todos";
  setTipo: React.Dispatch<
    React.SetStateAction<"urbano" | "rural" | "todos">
  >;
}

interface IGuiaProviderProps {
  children: ReactNode;
}

const GuiaContext = createContext({} as IGuiaContextData);

function GuiaProvider({ children }: IGuiaProviderProps) {
  const [loading, setLoading] = useState(false);
  const [chave, setChave] = useState(0);
  const [numero, setNumero] = useState(0);
  const [guia, setGuia] = useState({} as IGuia);
  const [guias, setGuias] = useState([] as IGuia[]);
  const { bancoPrefeitura } = usePrefeitura();
  const [periodoInicial, setPeriodoInicial] = useState("");
  const [periodoFinal, setPeriodoFinal] = useState("");
  const [ordenacao, setOrdenacao] = useState({} as Order);
  const [somenteResumo, setSomenteResumo] = useState(false);
  const [baseTotal, setBaseTotal] = useState(0);
  const [itbiTotal, setItbiTotal] = useState(0);
  const [tipo, setTipo] = useState<"urbano" | "rural" | "todos">("todos");
  const [id_adquirinte, set_id_adquirinte] = useState(0);

  function handleOrdenacao(
    tipo: "PERIODO" | "STATUS" | "BASE" | "ISSQN" | "INFORMANTE" | "ISSQN"
  ) {
    setOrdenacao({ ORDER: ordenacao.ORDER == 1 ? -1 : 1, PARAMETRO: tipo });
    //helpTimeOut();
  }

  async function helpTimeOut() {
    setLoading(true);
    await new Promise((r) => setTimeout(r, 1));
    setLoading(false);
  }
  async function getGuia() {
    try {
      setLoading(true);
      //window.alert(JSON.stringify(bancoPrefeitura))
      const { data } = await axios.post(
        base_url_unico_api + `/informar/chave/${chave}/numero/${numero}`,
        {
          bancoNome: bancoPrefeitura.replace("1-", "").replace("2-", ""),
          bancoNum: bancoPrefeitura.substring(0, 1),
        }
      );
      // window.alert(JSON.stringify(data));
      if (data.length > 0) {
        setGuia(data[0]);
      }
    } catch (e) {
      // window.alert(JSON.stringify(e));
      console.log(e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (chave > 0 && numero > 0) {
      getGuia();
    } else {
      setGuia({} as IGuia);
    }
  }, [chave, numero, bancoPrefeitura,]);

  async function getGuias() {

    try {
      setLoading(true);
      const { data } = await axios.post(
        base_url_unico_api +
        `/informar/periodoInicial/${periodoInicial}/periodoFinal/${periodoFinal}?tipo=${tipo}&id_adquirinte=${id_adquirinte}`,
        {
          bancoNome: bancoPrefeitura.replace("1-", "").replace("2-", ""),
          bancoNum: bancoPrefeitura.substring(0, 1),
        }
      );
      setGuias(data);
    } catch (e) {
      //window.alert(JSON.stringify(e))
    } finally {
      setLoading(false);
    }
  }

  function calculaGuias() {
  let totalBase = 0;
  let totalItbi = 0;

  for (let index = 0; index < guias.length; index++) {
    const element = guias[index];
      console.log(element.BASE )
    totalBase += Number(element.BASE || 0);
    totalItbi += Number(element.ISSQN || 0);
  }

  setBaseTotal(totalBase);
  setItbiTotal(totalItbi);
}

  function ordenar() {
    const lista_ordenada = guias.sort((a, b) => {
      let order_:
        | "PERIODO"
        | "COMPUTADA"
        | "PROCESSO"
        | "BASE"
        | "ISSQN"
        | "PROCESSO"
        | "CPFINFORMANTE"
        | "ISSQN" = "PERIODO";

      if (ordenacao.PARAMETRO == "STATUS") {
        order_ = "COMPUTADA";
      } else if (ordenacao.PARAMETRO == "INFORMANTE") {
        order_ = "CPFINFORMANTE";
      } else {
        order_ = ordenacao.PARAMETRO;
      }

      if (a[order_] > b[order_]) return ordenacao.ORDER;
      if (a[order_] < b[order_]) return -ordenacao.ORDER;
      return 0;
    });
    setGuias([...lista_ordenada]);
    helpTimeOut();
  }

  useEffect(() => {
    ordenar();
  }, [ordenacao]);

  useEffect(() => {
    if (periodoFinal.length > 0 && periodoInicial.length > 0) {
      getGuias();
    }
  }, [periodoInicial, periodoFinal, tipo,id_adquirinte]);

  useEffect(() => {
    calculaGuias();
  }, [guias]);

  return (
    <GuiaContext.Provider
      value={{
        chave,
        setChave,
        numero,
        setNumero,
        guia,
        guias,
        setPeriodoInicial,
        setPeriodoFinal,
        periodoInicial,
        periodoFinal,
        loading,
        ordenacao,
        setOrdenacao,
        handleOrdenacao,
        itbiTotal,
        baseTotal,
        somenteResumo,
        setSomenteResumo,
        tipo,
        setTipo, id_adquirinte, set_id_adquirinte
      }}
    >
      <>
        {children}

        <ModalLoader loading={loading} />
      </>
    </GuiaContext.Provider>
  );
}

function useGuia() {
  const context = useContext(GuiaContext);

  return context;
}

export { GuiaProvider, useGuia };
